import { render, staticRenderFns } from "./ok.vue?vue&type=template&id=7258abc9&"
import script from "./ok.vue?vue&type=script&lang=js&"
export * from "./ok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports